import React, { useState } from 'react';
import { Button } from '@c2fo/liquidity';
import { DivisionSearch, type Division } from '../../../../components/DivisionSearch';

interface AddDivisionFormProps {
  userId: string;
  userName: string;
  disabled?: boolean;
  onCancel: () => void;
  onConfirm: (selectedDivisions: Division[]) => void;
}

export const AddDivisionForm: React.FC<AddDivisionFormProps> = ({
  userId: _userId,
  userName: _userName,
  disabled = false,
  onCancel,
  onConfirm,
}) => {
  const [selectedDivisions, setSelectedDivisions] = useState<Division[]>([]);

  const handleConfirmClick = () => {
    if (selectedDivisions.length > 0) {
      onConfirm(selectedDivisions);
    }
  };

  return (
    <div
      className="mb-4 p-4 border border-gray-300 rounded bg-gray-50"
      data-testid="add-division-form"
      aria-label="Add Division Form"
    >
      <DivisionSearch
        selectedDivisions={selectedDivisions}
        onDivisionsChange={setSelectedDivisions}
        searchEndpoint="api/admin/v2/division/search"
        placeholder="Division Name or ID"
        showSelectedList={false}
      />

      {selectedDivisions.length > 0 && (
        <div className="mt-4 flex gap-2">
          <Button
            type="button"
            variant="primary"
            size="sm"
            onClick={handleConfirmClick}
            disabled={disabled}
            aria-label={`Add ${selectedDivisions.length} division${selectedDivisions.length > 1 ? 's' : ''} to user`}
          >
            Add Division{selectedDivisions.length > 1 ? 's' : ''}
          </Button>
          <Button type="button" variant="secondary" size="sm" onClick={onCancel} aria-label="Cancel adding division">
            Cancel
          </Button>
        </div>
      )}
    </div>
  );
};
